import {convertCoordinates} from '@/api/util-coordinates';

class ProtectedAreaApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    name,
    province,
    region,
    description,
    cx,
    cy,
    // visible,
    id}) {
    return {
      name,
      province,
      region,
      description,
      id,
      coordinates: convertCoordinates(cx, cy),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default ProtectedAreaApiResponseModel;
